const { READ_ONLY_FEATURES } = process.env;

export const uiConfig = {
    name: 'Lists',
    withActions: [],
    primaryKey: 'listId',
    onFormMount: (data, hookFxns) => {
        switch (data.listType) {
            case 'CODE':
                hookFxns.maybeUpdateOptionsMap('code');
                hookFxns.maybeUpdateOptionsMap('codeSystem');
                hookFxns.updateCodeSystem(data.cdsCodeSystemDTO.codeSystemId);
                break;
            case 'CODE_SYSTEM':
                hookFxns.maybeUpdateOptionsMap('codeSystem');
                break;
            case 'VALUE_SET':
                hookFxns.maybeUpdateOptionsMap('valueSet');
                hookFxns.updateCodeSystem(data.valueSetDTO.valueSetId);
                break;
            default:
                break;
        }
        return null;
    },
    preChangeBind: (value, onChange, hookFxns) => {},
    properties: {
        code: {
            name: 'Code',
            input: 'text',
            rowDisplay: true,
            editable: true,
            nullable: false,
            filterable: true
        },
        name: {
            name: 'Name',
            input: 'text',
            rowDisplay: true,
            editable: true,
            nullable: false,
            filterable: true
        },
        // listType: {
        //     name: 'Type',
        //     sortable: true,
        //     filterable: true,
        //     options: {
        //         [listTypes.AD_HOC]: listTypes.AD_HOC,
        //         [listTypes.AD_HOC_CONCEPT]: listTypes.AD_HOC_CONCEPT,
        //         [listTypes.JAVA_ENUM]: listTypes.JAVA_ENUM
        //     },
        //     input: (v) => (v?.listId && v?.listType ? 'valueDisplay' : 'select'),
        //     rowDisplay: true,
        //     postChangeBind: (v, onChange, hookFxns) => {
        //         onChange('listType', listTypes[v], true);
        //         hookFxns.maybeUpdateOptionsMap(
        //             {
        //                 VALUE_SET: 'valueSet',
        //                 CODE_SYSTEM: 'codeSystem',
        //                 CODE: 'code'
        //             }[v]
        //         );
        //     }
        // },
        // cdsCodeSystemDTO: {
        //     name: 'Code System',
        //     sortable: true,
        //     rowDisplay: false,
        //     accessorOverride: (v) => {
        //         return v?.codeSystemId;
        //     },
        //     input: (v) => {
        //         return [listTypes.CONCEPT, listTypes.CODE_SYSTEM].includes(v.listType) ? 'select' : null;
        //     },
        //     postChangeBind: (v, onChange, hookFxns) => {
        //         hookFxns.updateCodeSystem(v);
        //     },
        //     inputLabel: 'Code System'
        // },
        // valueSetDTO: {
        //     name: 'Value Set DTO',
        //     referenceDTO: 'org.cdsframework.dto.ValueSetDTO',
        //     referenceResourceName: 'valuesets',
        //     referenceResourcePlugin: 'cds',
        //     sortable: true,
        //     rowDisplay: false,
        //     accessorOverride: (v) => {
        //         return v?.valueSetId;
        //     },
        //     input: (v) => {
        //         return v?.listType === listTypes.VALUE_SET ? 'select' : null;
        //     },
        //     postChangeBind: (v, onChange, hookFxns) => {
        //         hookFxns.updateValueSet(v);
        //     },
        //     inputLabel: 'Value Set'
        // },
        // enumClass: {
        //     name: 'Enumeration Class',
        //     sortable: true,
        //     rowDisplay: false,
        //     input: (v) => {
        //         if (v.listType !== listTypes.JAVA_ENUM) return null;
        //         return v?.listId ? 'valueDisplay' : 'text';
        //     },
        //     inputLabel: 'Enumeration Class'
        // },
        listId: {
            name: 'List ID',
            rowDisplay: false,
            editable: false
        },
        createDatetime: {
            name: 'Created Datetime',
            rowDisplay: false,
            editable: false
        },
        createId: {
            name: 'Created by',
            rowDisplay: false,
            editable: false
        },
        lastModDatetime: {
            name: 'Last Modified',
            rowDisplay: false,
            editable: false
        },
        lastModId: {
            name: 'Last Modified By',
            rowDisplay: false,
            editable: false
        },
        uuid: {
            name: 'UUID',
            rowDisplay: false,
            editable: false
        }
    },
    newDoc: {
        cdsCodeSystemDTO: null,
        valueSetDTO: null,
        enumClass: null,
        code: null,
        listType: null,
        name: null
    },
    sortBy: {
        columnId: 'name',
        desc: false
    }
};

export default uiConfig;
